// src/components/ui/Card.tsx
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  borderColor?: string;
  padding?: 'sm' | 'md' | 'lg';
  hover?: boolean;
  variant?: 'default' | 'elevated' | 'flat';
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  borderColor,
  padding = 'md',
  hover = false,
  variant = 'default',
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const variantClasses = {
    default: 'bg-white rounded-xl shadow-card border border-neutral-border',
    elevated: 'bg-white rounded-xl shadow-xl border border-neutral-border/50',
    flat: 'bg-neutral-bg rounded-xl border border-neutral-border',
  };

  const hoverClasses = hover ? 'hover:shadow-card-hover hover:border-teal-light/30 transition-all duration-300 cursor-pointer' : '';

  return (
    <div
      className={`
        ${variantClasses[variant]}
        ${borderColor ? `border-l-4 ${borderColor}` : ''}
        ${paddingClasses[padding]}
        ${hoverClasses}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Card;